// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import NoteTextArea from './logic'

export default function NoteTextAreaFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/NoteTextArea">
      <NoteTextArea {...props}>
        {children}
      </NoteTextArea>
    </Flow>
  )
}
